import { SectionState } from "../shared/models/sections.model";

export class FlowsFIRenewalLoginModel {
  // Login customer number
  customerno!: string;

  // Login agreement number
  agreementno!: string;

  // Login landing page redirect url
  redirectToRenewalPageUrl!: string;

  // Login state
  state?: SectionState;

  // Login API Order Response
  loginOrderResponse!: LoginOrderResponse;
}

export class LoginOrderResponse {
  // Customer Number from Order Response API
  customerNumber!: string;

  // Agreement Number from Order Response API
  agreementNumber!: string;

  // Is Valid user boolean from Order Response API
  isValidUser!: boolean;

  // Is Campaign Active boolean from Order Response API
  isActiveForCampaign!: boolean;
}
